import { FreeTierOverlay } from '@/components/app-overlay/FreeTierOverlay.jsx'
import { useTierGuard } from '@/hooks/useTierGuard.jsx'

// Block the entire App unless the user is paying for a subscription
export const FreeTierLockGuard = ({ children }) => {

    const isPayingUser = useTierGuard(1)

    return (
        isPayingUser ? children : <FreeTierOverlay />
    )
}